<template>
  <v-layout
    pa-1
    align-center
    fill-height
    fluid
    row
    class="controls-layout"
  >
    <Settings class="settings" v-if="showSettings" />
    <v-flex shrink v-if="playState">
      <v-btn
        dark
        icon
        @click="pause"
      >
        <v-icon large>pause</v-icon>
      </v-btn>
    </v-flex>
    <v-flex shrink v-else>
      <v-btn
        dark
        icon
        @click="play"
      >
        <v-icon large>play_arrow</v-icon>
      </v-btn>
    </v-flex>
    <v-flex
      grow
      @mouseleave="mouseleave"
    >
      <v-slider
        v-model="sliderProgress"
        dark
        color="grey darken-2"
        track-color="white"
        @mousedown="active"
        @mouseup="inactive"
        @change="valueChanged"
      ></v-slider>
    </v-flex>
    <v-flex shrink align-self-center class="pl-2 hidden-xs-only">
      <p class="ma-0 text-xs-center">{{timeRemaining}}</p>
    </v-flex>
    <v-flex shrink>
      <v-btn
        class="mr-0"
        dark
        icon
        @click="toggleSettings"
      >
        <v-icon :color="this.showSettings ? 'white' : 'grey darken-2'" large>settings</v-icon>
      </v-btn>
    </v-flex>
    <v-flex shrink>
      <v-btn
        dark
        icon
        @click="toggleMute"
      >
        <v-icon large>{{volumeIcon}}</v-icon>
      </v-btn>
    </v-flex>
    <v-flex
      v-if="!isMobileDevice"
      xs1
      class="pr-3"
      align-self-center
    >
      <v-slider
        v-model="volume"
        dark
        color="grey darken-2"
        track-color="white"
      ></v-slider>
    </v-flex>
    <v-flex pr-1 shrink>
      <v-btn
        dark
        icon
        :disabled='!reportUrl'
      >
        <a :href="reportUrl" download class="white--text">
          <v-icon large>picture_as_pdf</v-icon>
        </a>
      </v-btn>
    </v-flex>
</v-layout>
</template>

<script>
/* eslint func-names: ["error", "never"] */
/* eslint object-shorthand: 0 */
import { isMobileDevice } from '@/utils/platform';
import Settings from './Settings.vue';

export default {
  name: 'VideoControls',
  props: {
    qualitySelector: {
      type: Boolean,
      required: false,
    },
  },
  components: {
    Settings,
  },
  data() {
    return {
      sliderActive: false,
      sliderProgress: 0,
      showSettings: false,
    };
  },
  watch: {
    currentTime(/* val */) {
      if (!this.sliderActive) this.sliderProgress = (this.currentTime / this.duration) * 100;
    },
  },
  computed: {
    isMobileDevice() {
      return isMobileDevice();
    },
    volumeIcon() {
      let ret = '';
      const { muted } = this.$store.state;
      if (this.volume === 0 || muted) {
        ret = 'volume_off';
      } else if (this.volume > 0 && this.volume < 50) {
        ret = 'volume_down';
      } else {
        ret = 'volume_up';
      }
      return ret;
    },
    volume: {
      get() {
        return this.$store.state.volume * 100;
      },
      set(val) {
        this.$player.setVolume((val / 100));
        const { layout } = this.$store.state.project;
        if (layout === '2D' && val > 0) this.$player.unMute();
      },
    },
    reportUrl() {
      return this.$store.state.project.reportUrl || null;
    },
    playState() {
      return this.$store.state.playState;
    },
    duration() {
      return this.$store.state.duration;
    },
    currentTime() {
      return this.$store.state.currentTime;
    },
    timeRemaining() {
      const timeRemaining = Math.round(this.duration - this.currentTime);
      const minutesRemaining = Math.floor(timeRemaining / 60);
      const secondsRemaining = Math.floor(timeRemaining - minutesRemaining * 60);
      const sec = secondsRemaining.toString().padStart(2, '0');
      const min = minutesRemaining.toString().padStart(2, '0');
      return `${min}:${sec}`;
    },
  },
  methods: {
    toggleMute() {
      const { layout } = this.$store.state.project;
      if (this.volume !== 0 && this.volume) {
        this.oldVol = this.volume;
        this.$player.setVolume(0);
      } else {
        const vol = this.oldVol || 100;
        this.$player.setVolume(vol / 100);
      }
      if (layout === '2D') this.$player.toggleMute();
    },
    valueChanged(val) {
      this.$player.seekTo((val / 100) * this.duration);
    },
    active() {
      this.sliderActive = true;
    },
    inactive() {
      this.sliderActive = false;
    },
    mouseleave() {
      this.sliderActive = false;
    },
    play() {
      this.$player.play();
    },
    pause() {
      this.$player.pause();
    },
    loop() {
      this.$player.toggleLoop();
    },
    toggleSettings() {
      this.showSettings = !this.showSettings;
    },
  },
};
</script>

<style scoped>

.controls-layout {
  background-color: rgba(0, 0, 0, 0.6);
  border-radius: 5px;
  color: white;
  border-color: grey;
  border-style: solid;
  border-width: thin;
}

.settings {
  position: absolute;
  right: 0px;
  bottom: 55px;
  width: 150px;
  background-color: rgba(0, 0, 0, 0.6);
  border-radius: 5px;
  color: white;
  border-color: grey;
  border-style: solid;
  border-width: thin;
}

</style>
